// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth} from "firebase/auth";
import {getFirestore} from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDZ_-lfYdTPJscFvny1p1l0ndZR7l2R1N4",
  authDomain: "ecological-react-ui.firebaseapp.com",
  projectId: "ecological-react-ui",
  storageBucket: "ecological-react-ui.firebasestorage.app",
  messagingSenderId: "432664602334",
  appId: "1:432664602334:web:f0b4f87bdd1280c0a9844f"
};




// Initialize Firebas

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export const db=getFirestore(app);

export { auth };